import { EventType } from 'shared/interface';
import { CouponDetailStatusCode } from 'shared/util/utility';

export enum CouponResultText {
	LOST = 'details-lost',
	PLACED = 'details-placed',
	WON = 'details-won',
	CANCELLED = 'details-cancelled',
	CASHOUT = 'details-cashedout',
}

export enum SlipType {
	AKO = 0,
	SYSTEM = 1,
	SOLO = 100,
}

// for more info/explanation on errors: https://betfan.atlassian.net/wiki/spaces/BP/pages/55377926/Tabela+b+d+w
export enum BetslipErrors {
	GAME_NOT_COMBINABLE = 5,
	GAME_UNAVAILABLE = 7,
	EVENT_UNAVAILABLE = 8,
	GAME_OUTCOME_UNAVAILABLE = 9,
	STAKE_LIMIT_REACHED_SINGLE = 11,
	CUSTOMER_STAKE_LIMIT_REACHED = 13,
	CUSTOMER_POSSIBLE_RETURN_LIMIT_REACHED = 15,
	ODDS_TOO_LOW = 17,
	ODDS_CHANGED = 18,
	ACCOUNT_CLOSED = 19,
	BETTING_DISABLED = 20,
	STAKE_TOO_LOW = 21,
	BETTING_DISABLED_WHEN_ACCOUNT_BLOCKED = 24,
	ODDS_PRODUCT_TOO_HIGH = 29,
	SINGLE_SLIP_TO_ACCEPT_FOR_TRADER = 30,
	MULTI_SLIP_TO_ACCEPT_FOR_TRADER = 31,
	TOO_FEW_OUTCOMES = 32,
	EVENT_CANNOT_BE_COMBINED_WITH_SELECTION = 33,
	TOO_MANY_OUTCOMES = 34,
	SAME_SLIP_IN_SHORT_PERIOD_OF_TIME = 35,
	WRONG_EVENT_TYPE = 38,
	WRONG_CATEGORY = 40,
	CUSTOMER_OUTCOME_POSSIBLE_RETURN_LIMIT_REACHED = 43,
	IP_ADDRESS_IS_BLOCKED = 45,
	REJECTED_BY_BETRADAR_MTS = 46,
	POSSIBLE_RETURN_TOO_LOW = 54,
	ODDS_PRODUCT_TOO_LOW = 55,
	CUSTOMER_DAILY_STAKE_LIMIT_REACHED = 56,
	IDS_CANNOT_BE_COMBINED_WITHIN_SET = 75,
	DISALLOWED_REG_METHOD = 82,
	CANNOT_COMBINE_CATEGORY = 98,
	CATEGORY_LEVEL_1_UNAVAILABLE = 114,
	CATEGORY_LEVEL_2_UNAVAILABLE = 115,
	CATEGORY_LEVEL_3_UNAVAILABLE = 116,
	OFFER_CONDITIONS_NOT_MET_TO_PLACE_BET = 205,
	OFFER_EVENT_START_AFTER_BONUS_EXPIRE_TIME = 206,
	OFFER_FREEBET_VALIDATION_FAILED = 207,
	OFFER_NOT_AVAILABLE_FOR_BET_TYPE = 209,
	OFFER_STAKE_TOO_HIGH = 210,
	OFFER_CONFIGURED_FOR_SPECIFIC_EVENT_TYPES = 211,
	OFFER_LOCKED_REQUIREMENTS_NOT_FULFILLED = 212,
	OFFER_CONFIGURED_FOR_SPECIFIC_CATEGORY = 214,
	OFFER_NOT_FOUND = 215,
	MAX_POSSIBLE_RETURN = 222,
	FORBIDDEN_CATEGORY = 223,
	FORBIDDEN_EVENT = 224,
	MANAGED_TRADING_SERVICE_BET_REJECTED = 301,
	TEMPORARY_ACCOUNT_TIME_LIMIT_REACHED = 400,
	TEMPORARY_ACCOUNT_TRANSACTION_LIMIT_REACHED = 401,
}

export enum OutcomeOddsUpdateState {
	ODDS_NOT_CHANGED = 1,
	ODDS_INCREASED = 2,
	ODDS_DECREASED = 3,
}

export interface BetBuilderOddsArray {
	gameName: string;
	name: string;
}

interface SlipCombinations {
	bonus: any;
	confirmedReturn: number;
	odds: number;
	oddsNoGain: number;
	outcomeIds: number[];
	possibleReturn: number;
	stake: number;
	status: number;
	tax: number;
}

export interface TransactionDetails {
	argument: number;
	banker: boolean;
	betBuilderOddsArray: BetBuilderOddsArray[];
	blockId?: null | number;
	brLiveEventIdRunningForPrematch: number;
	cat3DisplayedAs: string;
	categoryLev2: number;
	categoryLev3: number;
	categoryName1: string;
	categoryName2: string;
	categoryName3: string;
	changeType: null;
	earlyPayoutAvailable: boolean;
	eventId: number;
	eventName: string;
	eventStart: number;
	eventType: EventType;
	extras: {
		PeriodLength: string;
		OvertimeLength: string;
		additionalProp3: string;
	};
	gameId: number;
	gameInfo: Record<string, string>;
	gameName: string;
	gameTypeId: number;
	isBetBuilder: boolean;
	isEsport: true;
	liveEventId: number;
	modifiedOn: Date;
	odds: number;
	outcomeId: number;
	outcomeName: string;
	outcomeResult: string;
	participants: string;
	remoteId: number;
	score: string;
	sportId: number;
	statusCode: number;
	virtualType: null;
	info: string;
	time: number;
}

export interface CouponData {
	bonus: number;
	cashoutDetails?: {
		currentCashoutAmount: any;
	};
	cashoutable: boolean;
	confirmedReturn: number;
	decidedDate: number;
	gameId: number;
	isFreebet: boolean;
	possibleReturn: number;
	regDate: number;
	regMethod: number;
	resultText?: CouponResultText;
	showCombinationDetails: boolean;
	slipType: number;
	stake: number;
	statusCode: CouponDetailStatusCode;
	tax: number;
	taxConfirmed: number;
	taxFactor?: number;
	totalOdds: number;
	totalOddsWithoutSalesTaxFactor: number;
	transactionDetails: TransactionDetails[];
	transactionId: number;
	transactionType: number;
	transactionsCount: number;
	totalWinning: number;
	slipCombinations?: {
		combinations: SlipCombinations[];
	};
}

export interface AkoBonusData {
	bonusStepFrom: number;
	currentBonusValue: number;
	futureBonusValue: number;
	minOutcomeOdds: number;
	bonusAmount: number;
}

export interface OutcomeUpdate {
	outcomeId: number;
	outcomeOdds: number;
}

export enum OddsChangeRules {
	ACCEPT_ALL_ODDS_CHANGES = 'acceptAnyOdds',
	ACCEPT_HIGHER_ODDS_CHANGES = 'acceptHigherOdds',
	ACCEPT_NO_ODDS_CHANGES = 'addAccumulator',
}
